// Modules
import styled from "styled-components"

// Colors
import colors from "~constants/colors"

const StatusBadget = styled.span`
  border-radius: 100%;
  display: inline-block;
  height: 11px;
  width: 11px;
`

export const ActiveStatus = styled(StatusBadget)`
  background-color: ${colors.caribbean};
`

export const InactiveStatus = styled(StatusBadget)`
  background-color: ${colors.gray2};
`
